/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";

export function BenefisCategoryDeleteDialogHeader({ id }) {
  const [title, setTitle] = useState("");
  // Channel Redux state
  const { benefisCategoryForEdit, actionsLoading } = useSelector(
    (state) => ({
      benefisCategoryForEdit: state.benefisCategory.benefisCategoryForEdit,
      actionsLoading: state.benefisCategory.actionsLoading,
    }),
    shallowEqual
  );

  return (
    <>
      {actionsLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="modal-sizes-title-lg">
          Delete Payment Method
        </Modal.Title>
      </Modal.Header>
    </>
  );
}
